import { LiveAgentActivity } from "../chat/parts/LiveAgentActivity";

/** Activity tab — wraps the existing LiveAgentActivity panel. The
 *  wrapping div carries the rail-body padding; the inner component
 *  brings its own idle / phase / tool-call markup, so we don't
 *  duplicate that here. */
export function RightRailActivity(): JSX.Element {
  return (
    <div className="teacher-rail-content">
      <LiveAgentActivity />
    </div>
  );
}
